import { render, staticRenderFns } from "./emaillist.vue?vue&type=template&id=36d96751&scoped=true&"
import script from "./emaillist.vue?vue&type=script&lang=js&"
export * from "./emaillist.vue?vue&type=script&lang=js&"
import style0 from "./emaillist.vue?vue&type=style&index=0&id=36d96751&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d96751",
  null
  
)

export default component.exports